export function propertyExists(obj, prop) {
  return (
    typeof obj === "object" &&
    obj !== null &&
    Object.prototype.hasOwnProperty.call(obj, prop)
  )
}
